var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.containerClasses},_vm._l((_vm.getPostCount(_vm.index)),function(i){return _c('div',{key:i,class:_vm.$style.post})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }